import SnackBar, { openSnackbar } from "./SnackBar";

export default SnackBar;

export { SnackBar, openSnackbar };
